import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Pharmasist.css";

const Pharmasist = () => {
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const response = await axios.get("https://pharmabackend-1.onrender.com/api/job-applications/Pharmasist");
        setApplications(response.data);
      } catch (error) {
        console.error("Error fetching applications:", error);
      }
    };

    fetchApplications();
  }, []);

  return (
    <div className="Pharmasist-main1">
      <h2>Pharmasist Applications</h2>
      <table className="Pharmasist-table-box">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Education</th>
            <th>Experience</th>
            <th>Resume</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {applications.map((application) => (
            <tr key={application._id}>
              <td>{application.name}</td>
              <td>{application.phone}</td>
              <td>{application.email}</td>
              <td>{application.education}</td>
              <td>{application.experience}</td>
              <td>
                <a href={`https://pharmabackend-1.onrender.com/${application.resume}`} target="_blank" rel="noopener noreferrer">
                  View Resume
                </a>
              </td>
              <td>{new Date(application.createdAt).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Pharmasist;